(function ($) {
    //Make a foreach swiperjs, so i can have multiple swiper on the same page

    AOS.init();

    new PureCounter({
        selector: ".number",
        separator: true,
        formater: "nl-NL",
        decimals: 0,
    });

    $(".swiper-container").each(function () {
        var swiper = new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
            },
        });
    });

    //New swiper USP swiper

    var swiper = new Swiper(".swiper-container-usp", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        direction: "vertical",
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination-usp",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next-usp",
            prevEl: ".swiper-button-prev-usp",
        },
    });

    $(window).on("scroll", function () {
        var scrollPosition = $(document).scrollTop();
        $(".faq-category").each(function () {
            var color = $(".faq-sidebar ul li a").data("active-color");

            var currentId = $(this).attr("id");
            var currentOffset = $(this).offset().top - 200;
            if (scrollPosition >= currentOffset) {
                $(".faq-sidebar ul li").removeClass("active");
                $(".faq-sidebar ul li")
                    .eq($(`#${currentId}`).index())
                    .addClass("active");

                $(".faq-sidebar ul li.active a").css("background-color", color);

                //make other items not active
                $(".faq-sidebar ul li").each(function () {
                    if (!$(this).hasClass("active")) {
                        $(this)
                            .find("a")
                            .css("background-color", "transparent");
                    }
                });
            }
        });
    });

    /// News
    $(".all").click(function () {
        // Uncheck all checkboxes
        $('#filter input[type="checkbox"]').prop("checked", false);
        $("#filter").trigger("change");
    });

    $('#filter input[type="checkbox"]')
        .not("#all")
        .click(function () {
            // Uncheck the "#all" checkbox
            $("#all").prop("checked", false);
        });

    /////// MENU ITEM TOGGLE
    $("#wrapper-navbar .menu-icon").on("click", function () {
        $("body,html").animate({ scrollTop: 0 }, 150);
        $("#wrapper-navbar").toggleClass("active");
        $("body, html").toggleClass("no-scroll");
        $(".menu-wrapper").fadeToggle(150);
    });

    //if page has video
    if ($(".video-wrapper").length) {
        var iframe = document.querySelector("iframe");
        var player = new Vimeo.Player(iframe);
    }

    $(".play-button.play").on("click", function () {
        $(".background-model").fadeIn();
        $(".video-wrapper").addClass("active");
        $("body").addClass("no-scroll");
        $(".play-button.close").fadeIn().css("display", "flex");
        $(this).fadeOut();

        // Scroll het video naar het midden van het scherm
        var video = $(".video-wrapper.active");
        var videoHeight = video.outerHeight();
        var videoOffset = video.offset().top;
        var windowHeight = $(window).height();
        var scrollPosition = videoOffset - (windowHeight / 2 - videoHeight / 2);
        $("html, body").animate({
            scrollTop: scrollPosition,
        });

        // Verander de src van de iframe zodat controls=1 wordt
        var src = iframe.getAttribute("src");
        src = src.replace("controls=0", "controls=1");
        src = src.replace("muted=1", "muted=0");

        iframe.setAttribute("src", src);
    });

    $(".play-button.close").on("click", function () {
        $(".background-model").fadeOut();
        $(".video-wrapper").removeClass("active");
        $("body").removeClass("no-scroll");
        $(".play-button.play").fadeIn();
        $(this).fadeOut();
        player.setVolume(0);

        // Verander de src van de iframe zodat controls=0 wordt

        var src = iframe.getAttribute("src");
        src = src.replace("controls=1", "controls=0");
        src = src.replace("muted=0", "muted=1");
        iframe.setAttribute("src", src);
    });

    $(".faq-category ul li").on("click", function () {
        //find closest faq-content and slideIn
        // $(this).closest(".faq-category").find(".faq-content").slideUp();
        $(this).toggleClass("active");
        $(this)
            .closest(".faq-category")
            .find(".faq-content")
            .eq($(this).index())
            .slideToggle();
    });

    //Make the siebar items active based on the scroll position of the faq items. The faq title has the same id name as the sidebar items. Also give the active sidebar item the active color from the data-primary-color attribute

    //check if .option-wrapper input is checked and change the color of the label with the data-active-color attribute
})(jQuery);
